import { CitiesList } from 'entities/geo/cities/cities-list';
import { Heading } from 'shared/ui/list-page-heading';
import { useTitleHook } from 'hooks/page-title.hook';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useCitiesList } from 'entities/geo/cities/cities-list/cities-list.hook';
import { AddCityButton, AddCityDialog, useAddCityDialog, useAddCity, FormValues } from 'features/geo/city/add';
import { useDeleteCity } from 'features/geo/city/delete';
import { LoadingBanner } from '../../../shared/ui/loading-banner';
import { ErrorBanner } from '../../../shared/ui/error-banner';
import { Box } from '@mui/material';
import { GeoListFilter } from 'features/geo/geo-list-filter/ui';
import { useSearchParams } from 'react-router-dom';

const CitiesListPage = () => {
  useTitleHook('Города');

  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();

  const getCitiesSearchParams = () => {
    const relatedFields = ['name', 'regionId', 'countryId'];
    const newParams = new URLSearchParams();
    
    searchParams.forEach((value, key) => {
      if (relatedFields.includes(key)) {
        newParams.append(key, value);
      }
    });
    
    return newParams;
  };

  const collection = useCitiesList(paging, getCitiesSearchParams());
  const { closeDialog } = useAddCityDialog();
  const addCity = useAddCity();
  const handleAddCity = async (formValues: FormValues) => addCity(formValues).then(closeDialog);
  const handleDeleteCity = useDeleteCity();

  if (collection.isLoading) return <LoadingBanner />;
  if (collection.error) return <ErrorBanner errorMessage={collection.error} />;

  return (
    <>
      <Heading sx={{ mb: 2 }} title="Города" actions={<AddCityButton />} />
      <Box mb={1}>
        <GeoListFilter withRegionSearch={true} withCountrySearch={true} />
      </Box>
      <CitiesList 
        collection={collection} 
        paging={paging} 
        onChangePaging={setPaging} 
        onDelete={handleDeleteCity} 
      />
      <AddCityDialog onSubmit={handleAddCity} />
    </>
  );
};

export default CitiesListPage;